import Layout from '../components/Layout/Layout'
import Button from '../components/UI/Button'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <Layout>
      <div className="min-h-[60vh] flex items-center justify-center py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            {/* 404 Illustration */}
            <div className="mb-8">
              <div className="text-8xl sm:text-9xl font-bold text-primary-light">
                404
              </div>
            </div>
                        
            {/* Error Message */}
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-6">
              Página no encontrada
            </h1>
                        
            <p className="font-body font-light text-primary-text text-lg leading-relaxed mb-8">
              Lo sentimos, la página que estás buscando no existe. Te invitamos a explorar nuestros productos exclusivos desde nuestra página principal.
            </p>
                        
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button
                  variant="primary"
                  size="large"
                  className="font-semibold text-lg sm:text-base py-3 sm:py-4"
                >
                  Volver al Inicio
                </Button>
              </Link>
            </div>
                        
            {/* Helpful Links */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm sm:text-base text-primary-gray font-body font-normal mb-4">
                ¿No encuentras lo que buscabas? Prueba estos enlaces:
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-sm sm:text-base text-primary-gray font-body font-light">
                <Link
                  to="/categoria/Coronas de Reina"
                  className="hover:text-primary-dark hover:font-normal transition-colors"
                >
                  Coronas de Reina
                </Link>
                <span className="text-primary-gray">•</span>
                <Link
                  to="/categoria/Coronas"
                  className="hover:text-primary-dark hover:font-normal transition-colors"
                >
                  Coronas
                </Link>
                <span className="text-primary-gray">•</span>
                <Link
                  to="/categoria/Tiaras"
                  className="hover:text-primary-dark hover:font-normal transition-colors"
                >
                  Tiaras
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default NotFound